
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 43 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M13.416 7.465h17.441v16.289H13.416z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.135 21.48l-.002-12.018 11.475 6.03-11.473 5.987zm25.194-14.1s-.415-2.947-1.688-4.245c-1.615-1.704-3.425-1.712-4.255-1.811C30.443.89 21.53.89 21.53.89h-.019s-8.914 0-14.857.433c-.831.099-2.64.107-4.256 1.81C1.124 4.434.71 7.38.71 7.38S.285 10.84.285 14.302v3.245c0 3.462.425 6.922.425 6.922s.414 2.947 1.687 4.245c1.616 1.704 3.738 1.65 4.683 1.828 3.398.33 14.44.43 14.44.43s8.923-.013 14.866-.446c.83-.1 2.64-.108 4.255-1.812 1.273-1.298 1.688-4.245 1.688-4.245s.425-3.46.425-6.922v-3.245c0-3.46-.425-6.922-.425-6.922z","fill":"#CE1312"}})])
          )
        }
      }
    